import { render } from "./OnDemandForm.vue?vue&type=template&id=829124c2&ts=true"
import script from "./OnDemandForm.vue?vue&type=script&lang=ts"
export * from "./OnDemandForm.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Progetti\\K-Digitale\\DP365\\src\\Widgets\\dp365-we-ondemand\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__